import * as React from 'react';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import { Button, Card, Col, Divider, Modal, notification, Row, Table } from 'antd';

import LetterDataQuery from '../../components/Query/LetterData';
import LetterDataDetail from './LetterDataDetail';
import { Title } from '../../components/Layout/components';
import NotFoundPage from '../NotFound/NotFound';
import { getLetterDataTypes } from 'helpers/src/letterData/letterDataLetterTypes';

interface ILetterDataTableProps extends RouteComponentProps {
  domain: string;
  letterDataId?: string;
}

interface ILetterDataTableState {
}

class LetterDataTable extends React.Component<ILetterDataTableProps, ILetterDataTableState> {

  constructor(props: ILetterDataTableProps) {
    super(props);
  }

  public componentDidMount() {
    if ((this.props as any).onCollapse) {
      (this.props as any).onCollapse(false);
    }
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <LetterDataQuery
            domain={this.props.domain}
          >
            {({ letterData, createLetterData, updateLetterData, deleteLetterData }: any) => {
              return this.renderData(
                letterData,
                createLetterData,
                updateLetterData,
                deleteLetterData,
                letterData.refetch
              );
            }}
          </LetterDataQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    letterData: any,
    createLetterData: Function,
    updateLetterData: Function,
    deleteLetterData: Function,
    refetch: Function
  ) {
    if (letterData && !letterData.loading) {

      // formulář
      if (this.props && this.props.letterDataId) {
        const selectedLetterData = letterData.letterData.find((d: GQL.ILetterData) => d.id === this.props.letterDataId) || undefined;
        if (this.props.letterDataId !== 'new' && !selectedLetterData) {
          return <NotFoundPage domain={this.props.domain} />
        }
        return (
          <LetterDataDetail
            domain={this.props.domain}
            languages={letterData.languages}
            letterData={letterData.letterData.find((s: GQL.ILetterData) => s.id === this.props.letterDataId) || undefined}
            onSave={a => this.upsert(a, createLetterData, updateLetterData, refetch)}
            onCancel={() => this.cancel()}
          />
        );
      }
      const letterDataLetterTypes = getLetterDataTypes();

      return (
        <div>
          <Title>Letter data</Title>
          <Divider />
          <Link className="ant-btn" to={this.getLink('new')}>Create new letter data</Link>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={letterData.letterData}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column 
              title="Title" 
              dataIndex="title" 
              key="title" 
            />
            <Table.Column
              title="For state"
              dataIndex="state"
              key="state"
              width={300}
              render={(u, row: GQL.ILetterData) => {
                if (row.externalOrderState) {
                  return <span>{row.externalOrderState.title}</span>;
                }
                return null;
              }}
            />
            <Table.Column 
              title="Type" 
              dataIndex="type" 
              key="type"
              render={(u: any, row: any) => {if (letterDataLetterTypes[row.type]) {return letterDataLetterTypes[row.type]} return row.type}}
            />
            <Table.Column
              title="Actions"
              dataIndex="actions"
              key="actions"
              width={180}
              align="center"
              render={(u: any, row: any) => this.renderActions(u, row, deleteLetterData, refetch)}
            />
          </Table>
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading letter datas ..." style={{ width: '100%' }} />
      </div>
    );
  }

  private renderActions(u: any, letterData: GQL.ILetterData, deleteLetterData: Function, refetch: Function) {
    return (
      <div>
        <Link className="ant-btn" type={'dashed'} to={this.getLink(letterData.id)}>
          Edit
        </Link>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(letterData, deleteLetterData, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private delete(letterData: GQL.ILetterData, deleteLetterData: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete ${letterData.title}?`,
      content: (
        <span>
          Are you sure you want to delete letter data for <strong>{letterData.title}</strong>?
        </span>
      ),
      onOk: () => {
        return deleteLetterData({
          variables: {
            id: letterData.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(
    letterData: GQL.ILetterData,
    createLetterData: Function,
    updateLetterData: Function,
    refetch: Function
  ) {
    if (letterData != undefined) {
      const variables = {
        id: letterData.id,
        letterData: {
          title: letterData.title,
          subject: letterData.subject,
          text: letterData.text,
          externalOrderStateId: letterData.externalOrderStateId,
          attachmentInvoice: letterData.attachmentInvoice,
          attachmentProforma: letterData.attachmentProforma,
          sendInvoiceToCustomer: letterData.sendInvoiceToCustomer || false,
          sendProformaToCustomer: letterData.sendProformaToCustomer || false,
          type: letterData.type || null,
        }
      };

      if (letterData.id) {
        return updateLetterData({ variables })
        .then(() => refetch())
        .then(() => this.cancel())
        .then(() =>
            notification['success']({
              message: 'Info',
              description: `Letter data for "${variables.letterData.title}" has been updated.`
            })
          );
      }

      // (variables as any).letterData.externalOrderStateId = letterData.externalOrderStateId;
      (variables as any).letterData.domain = this.props.domain;

      createLetterData({ variables })
      .then(() => refetch())
      .then(() => this.cancel())
      .then(() =>
          notification['success']({
            message: 'Info',
            description: `Letter data for "${variables.letterData.title}" has been created.`
          })
        );
    }
  }

  private getLink(recordId: string | null) {
    return `/${this.props.domain}/application/letter-data${recordId ? `/${recordId}` : ''}`;
  }

  private cancel() {
    this.props.history.push(this.getLink(null));
  }
}

export default withRouter(LetterDataTable);



// WEBPACK FOOTER //
// ./src/scenes/LetterData/LetterDataTable.tsx